module.exports = __webpack_public_path__ + "img/CM-MR-26-Ford-Playful.34f63f62.jpg";